/**
 * Surface re-exports for `@deckspace/catalog`'s visualization registry.
 *
 * Web-app cannot import `@deckspace/catalog` directly (dep-cruiser rule
 * `web-app-limited-deps`), so this thin wrapper re-exports the lookup
 * functions and type. The local function name `getVisualizationDefinition`
 * (vs. catalog's `getVisualization`) keeps the public ui surface
 * self-describing.
 *
 * NOTE: `vite-plugin-dts` strips bare `export { x } from '@deckspace/catalog'`
 * re-exports from generated `.d.ts` files. Defining a local function here
 * forces the type into ui-components' surface.
 */

import {
  getVisualization,
  type VisualizationDefinition as CatalogVisualizationDefinition,
} from '@deckspace/catalog';

export type VisualizationDefinition = CatalogVisualizationDefinition;

export function getVisualizationDefinition(type: string): VisualizationDefinition | undefined {
  return getVisualization(type);
}
